import Loader from "components/shared/loader";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { getItemChangePoints } from "sources/books/bids";
import PlanItem from "./planItem";

const BidItemChanges = (props) => {
    const [items, setItems] = useState([]);
    const [hasParallelBidId, setHasParallelBidId] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const loadItems = () => {
        getItemChangePoints(props.bid.id).then((plan) => {
            const getTime = (item) => moment(item.planEnterDateOffset);
            const result = plan.sort((a, b) => getTime(a) - getTime(b));
            const itemsHasParallelBidId = plan.some((item) => item.parallelBidId);

            setHasParallelBidId(itemsHasParallelBidId);
            setItems(result);
            setLoading(false);
        });
    };

    useEffect(() => {
        loadItems();
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    const openForm = () =>
        props.switchComponent("form", {
            bidId: props.bid.id,
            itemType: "plan",
            hasParallelBidId,
            items,
        });

    if (items.length === 0) {
        return (
            <div className="bid-item-change-empty-state">
                <div className="bid-item-change-empty-state__message">
                    <p>По этой заявке еще нет перецепок и пересменок.</p>
                    <p>
                        Запланируйте замену машины, водителя или прицепа, если во время рейса нужно поменять
                        участника рейса.
                    </p>
                </div>
                <button type="button" className="btn btn-brand" onClick={openForm}>
                    Запланировать замену
                </button>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex pb-3 justify-content-end">
                <button type="button" className="btn btn-sm btn-brand" onClick={openForm}>
                    Запланировать замену
                </button>
            </div>
            <div className="table-responsive">
                <table className="table table-sm table-hover table-clickable">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Перецепка/пересменка</th>
                            <th>Плановая дата</th>
                            <th>Фактическая дата въезда</th>
                            <th>Фактическая дата выезда</th>
                            <th>Статус</th>
                            <th>Адрес</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, i) => (
                            <PlanItem
                                key={item.id}
                                i={i}
                                bid={props.bid}
                                bidId={props.bid.id}
                                switchComponent={props.switchComponent}
                                items={items}
                                item={item}
                                hasParallelBidId={hasParallelBidId}
                                itemChangesHistory={props.itemChangesHistory}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default BidItemChanges;
